import { useCallback } from "react";
import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { ZONE } from "tagTypes";

export const useZoneQuery = (premiseAreaId, query = {}) =>
  useGetQuery({
    endpoint: `/premise-area/${premiseAreaId}/zone`,
    query,
    tags: [ZONE],
  });

export const useLazyZoneQuery = () => {
  const [getZone, data] = useLazyGetQuery();
  const zone = useCallback(
    async (premiseAreaId, query = {}) =>
      await getZone(
        {
          endpoint: `/premise-area/${premiseAreaId}/zone`,
          query,
          tags: [ZONE],
        },
        true
      ).unwrap(),
    [getZone]
  );
  return [zone, data];
};

export const usePostZoneMutation = () => {
  const [zone, data] = usePostMutation();
  const addZone = async (payload, query = {}) =>
    await zone({
      endpoint: "/zone",
      query,
      payload: payload || {},
      toastMessage: "Zone added successfully",
      tags: [ZONE],
    }).unwrap();

  return [addZone, data];
};

export const usePutZoneMutation = () => {
  const [zone, data] = usePutMutation();
  const updateZone = async (payload, id, query = {}) =>
    await zone({
      endpoint: `/zone/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Zone updated successfully",
      tags: [ZONE],
    }).unwrap();
  return [updateZone, data];
};

export const useDeleteZoneMutation = () => {
  const [zone] = useDeleteMutation();
  const deleteZone = async (id, query = {}) =>
    await zone({
      endpoint: `/zone/${id}`,
      query,
      toastMessage: "Zone deleted successully",
      tags: [ZONE],
    }).unwrap();
  return [deleteZone];
};
